class QuickJumpBar extends HTMLElement {
    constructor() {
        super();
        this.items = [];
        this.sticky = false;
        this.announcementBarHeight = 0;
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.quick-jump-bar-item');
        this.sticky = this.dataset.sticky === "true";

        this.enableSticky();
        this.attachEvents();
        this.hasAnnouncementBar();
        this.showJumpBar();
    }

    enableSticky() {
        if (this.sticky) {
            document.body.classList.add('header_no_sticky');
        }
    }

    hasAnnouncementBar() {
        const announcementBar = document.querySelector('.announcement-bar-section');
        if (announcementBar) {
            this.announcementBarHeight = announcementBar.offsetHeight;
            window.addEventListener('resize', () => {
                this.announcementBarHeight = announcementBar.offsetHeight;
            });
        }
    }

    inTheArea() {
        const viewportCenter = window.innerHeight / 2 + window.scrollY;

        this.items.forEach(item => {
            const targetId = item.getAttribute('data-target-id');
            if (targetId) {

                const targetElement = document.getElementById(targetId);
                if (targetElement) {

                    const rect = targetElement.getBoundingClientRect();
                    const top = rect.top + window.scrollY;
                    const bottom = rect.bottom + window.scrollY;

                    if (viewportCenter >= top && viewportCenter <= bottom) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                }
            }
        });
    }

    jumpTo(event) {
        const targetId = event.currentTarget.getAttribute('data-target-id');
        const targetElement = document.getElementById(targetId);
        if (targetElement) {

            const offsetTop = this.sticky ? targetElement.offsetTop - this.offsetHeight : targetElement.offsetTop;

            window.scrollTo({
                top: offsetTop - this.announcementBarHeight,
                behavior: 'smooth'
            });

        }
        this.scrollItemToCenter(event.currentTarget);
    }

    scrollItemToCenter(item) {
        const wrapper = this.querySelector('.quick-item-box');
        const wrapperRect = wrapper.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const wrapperScrollLeft = wrapper.scrollLeft;

        const offsetLeft = itemRect.left - wrapperRect.left + wrapperScrollLeft - (wrapperRect.width / 2) + (itemRect.width / 2);

        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    scrollToItem(item) {
        const wrapper = item.parentElement;
        const itemRect = item.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        const offsetLeft = itemRect.left - wrapperRect.left + wrapper.scrollLeft;
        wrapper.scrollTo({
            left: offsetLeft,
            behavior: 'smooth'
        });
    }

    showJumpBar() {
        const quickJumpBarSection = document.querySelector('.section-quick-jump-bar');
        const placeholderDiv = document.createElement('div');
        let placeholderAdded = false;
        let isQuickJumpBarActive = false;

        // 记录初始位置
        const rect = this.getBoundingClientRect();
        const mainProductContainerBottom = rect.bottom + window.scrollY;

        if (quickJumpBarSection) {
            window.addEventListener('scroll', () => {
                if (window.scrollY > mainProductContainerBottom) {
                    if (!isQuickJumpBarActive) {
                        // 动态添加占位符，确保占位符先渲染
                        if (!placeholderAdded) {
                            placeholderDiv.classList.add('quick-jump-bar-placeholder');
                            placeholderDiv.style.height = `${quickJumpBarSection.offsetHeight}px`;
                            placeholderDiv.style.width = '100%';
                            placeholderDiv.style.display = 'block';
                            quickJumpBarSection.before(placeholderDiv);
                            placeholderAdded = true;
                        }

                        // 添加 `loading` 类，随后添加 `active` 类
                        quickJumpBarSection.classList.add('loading');
                        quickJumpBarSection.offsetHeight; 
                        quickJumpBarSection.classList.add('active');

                        setTimeout(() => {
                            quickJumpBarSection.classList.remove('loading');
                        }, 50); // 确保过渡生效
                        isQuickJumpBarActive = true;
                    }
                } else {
                    if (isQuickJumpBarActive) {
                        // 移除 `active` 类
                        quickJumpBarSection.classList.remove('active');

                        isQuickJumpBarActive = false;

                        // 移除占位符
                        if (placeholderAdded) {
                            placeholderDiv.remove();
                            placeholderAdded = false;
                        }
                    }
                }
            });
        }
    }

    attachEvents() {
        this.items.forEach(item => {
            item.addEventListener('click', this.jumpTo.bind(this));
            item.addEventListener('click', () => this.scrollToItem(item));
        });

        window.addEventListener('scroll', this.inTheArea.bind(this));
    }
}

customElements.define('quick-jump-bar', QuickJumpBar);
